<template>
  <div>
    <button @click="generateSitemap">生成Sitemap</button>
    <p v-if="sitemapUrl">Sitemap URL: {{ sitemapUrl }}</p>
    <a v-if="sitemapUrl" :href="sitemapUrl"  download="sitemap.xml">下载Sitemap</a>
  </div>
</template>

<script>
import { sitemap } from "@/api/home";
export default {
  data() {
    return {
      sitemapUrl: "",
    };
  },
  methods: {
    generateSitemap() {
      sitemap()
        .then((response) => {
          var pattern = /daily/g;
          var newStr = response.replace(pattern, "weekly");
          this.sitemapUrl = URL.createObjectURL(
            new Blob([newStr], { type: "application/xml" }),
          );
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/vue-sitemap.vue